/**
 * @file: MapAnchor.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 地图点位管理
 */
import request from '@/utils/request'

/**
 * 新增地图点位
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapAnchorAdd(data) {
  return request({
    type: 'biz',
    url: 'map/anchor/add',
    method: 'post',
    data
  })
}

/**
 * 删除地图点位
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapAnchorDelete(data) {
  return request({
    type: 'biz',
    url: 'map/anchor/delete',
    method: 'post',
    data
  })
}

/**
 * 获取地图点位详情
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapAnchorGet(data) {
  return request({
    type: 'biz',
    url: 'map/anchor/get',
    method: 'post',
    data
  })
}

/**
 * 地图点位管理列表(不分页)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapAnchorListGet(data) {
  return request({
    type: 'biz',
    url: 'map/anchor/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取点位列表（微信端）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapAnchorNotokenListGet(data) {
  return request({
    type: 'biz',
    url: 'map/anchor/notoken/list/get',
    method: 'post',
    data
  })
}

/**
 * 地图点位管理列表(分页)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapAnchorPageListGet(data) {
  return request({
    type: 'biz',
    url: 'map/anchor/page/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取点位列表（大屏专用）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapAnchorScreenListGet(data) {
  return request({
    type: 'biz',
    url: 'map/anchor/screen/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取数据范围列表（大屏专用）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapAnchorScreenOrgListGet(data) {
  return request({
    type: 'biz',
    url: 'map/anchor/screen/org/list/get',
    method: 'post',
    data
  })
}

/**
 * 修改地图点位
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapAnchorUpdate(data) {
  return request({
    type: 'biz',
    url: 'map/anchor/update',
    method: 'post',
    data
  })
}

/**
 * 获取当前登录人员所属组织下所有地图点位列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapAnchorWebListGet(data) {
  return request({
    type: 'biz',
    url: 'map/anchor/web/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取当前登录人员所属组织及城市ID下所有地图点位列表（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapDeptforcityListGet(data) {
  return request({
    type: 'biz',
    url: 'map/deptforcity/list/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/MapAnchor.js